import { ThemeUICSSObject, spacing } from '@apia/theme';
/* IMPORT HERE */

const modal: ThemeUICSSObject = {
  minWidth: '400px',
  maxWidth: '60vw',
  maxHeight: '80vh',
  overflow: 'auto',
  px: 3,
  pb: spacing(3),

  'h2,h3': {
    m: spacing(0),
  },

  h3: {
    color: 'primary',
    mt: spacing(4),
  },

  ul: {
    my: 4,
    listStyle: 'none',
    ml: spacing(0),
    pl: spacing(0),

    '&:last-of-type': {
      mb: spacing(0),
    },

    li: {
      mb: spacing(3),

      '&:last-of-type': {
        mb: spacing(0),
      },

      '& label': {
        display: 'flex',
        gap: spacing(4),
        alignItems: 'center',
        justifyContent: 'start',
      },
    },
  },
  /* PREPEND HERE */
};

export default modal;
